import { observer } from 'mobx-react';
import * as React from 'react';
import { TOGGLE_TYPE } from '../../constants/AutoReplenishment';
import { CheckBox } from '@estee/elc-checkbox';
import { Body2 } from '@estee/elc-typography';
import { ITranslationsCollection } from '@estee/elc-service';
import { Switch } from '@estee/elc-switch';
import styled from 'styled-components';
import { SUBSCRIBE_BUTTON } from '../../constants/DataTestIdAttributes';

export interface IToggleSelector {
    toggleType?: string;
    translations?: ITranslationsCollection;
    toggleAutoReplenish(isChecked: boolean): void;
    isAutoReplenishSelected: boolean;
    setAutoReplenishSelection(isSelected: boolean): void;
}

const SwitchWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const ToggleSelector = observer(function ToggleSelector(props: IToggleSelector) {
    const {
        toggleType,
        translations,
        toggleAutoReplenish,
        isAutoReplenishSelected,
        setAutoReplenishSelection
    } = props;

    const { subscribeLabel } = translations as ITranslationsCollection;

    switch (toggleType) {
        case TOGGLE_TYPE.CHECKBOX:
            return (
                <CheckBox
                    label={subscribeLabel}
                    value={'auto-replenish'}
                    onChange={toggleAutoReplenish}
                    isChecked={isAutoReplenishSelected}
                />
            );
        case TOGGLE_TYPE.SWITCH:
        default:
            return (
                <>
                    <Body2>{subscribeLabel}</Body2>
                    <SwitchWrapper>
                        <Switch
                            isSelected={isAutoReplenishSelected}
                            onToggle={setAutoReplenishSelection}
                            data-test-id={SUBSCRIBE_BUTTON}
                            title={'subscribeLabel'}
                        />
                    </SwitchWrapper>
                </>
            );
    }
});
